import { CommonTutorialCarousel } from 'app/src/features/Tutorial/components/CommonTutorialCarousel'
import VideoPlayer from 'app/src/features/Tutorial/components/VideoPlayer'
import { tutorialsApi } from 'app/src/services/welfareportal'
import { PageWidget } from 'app/src/shared/components'
import { Card } from 'primereact/card'
import { useTranslation } from 'react-i18next'

export function TutorialList() {
  const { t } = useTranslation('tutorial')
  const tutorialsResult = tutorialsApi.useTutorialRequestList({ queryParams: {} })

  const items = tutorialsResult.data?.items || []

  const tutorialTemplate = (tutorial: tutorialsApi.TutorialsBase) => {
    return <VideoPlayer videoSrc={tutorial.link} poster={tutorial.image} />
  }

  return (
    items.length > 0 && (
      <PageWidget background='cardBackGround'>
        <h3 className='mb-4'>{t('Tutorial.VideoSection.Title')}</h3>
        <div
          className='mb-4 line-clamp-5 max-h-36'
          dangerouslySetInnerHTML={{
            __html: t('Tutorial.VideoSection.Text'),
          }}
        ></div>
        <Card>
          <CommonTutorialCarousel value={items} itemTemplate={tutorialTemplate} />
        </Card>
      </PageWidget>
    )
  )
}
